import React, { useState, useEffect } from 'react'
import { Link, withRouter } from "react-router-dom";
import { Menu, Grid, message, Modal } from "antd";
import IntlMessage from "../util-components/IntlMessage";
import { useHistory } from "react-router";
import { connect } from "react-redux";
import { onMobileNavToggle } from "redux/actions/Theme";
import { SIDE_NAV_LIGHT, NAV_TYPE_SIDE } from "constants/ThemeConstant";
import utils from 'utils'
import { ADMIN_API_BASE_ENDPOINT } from 'configs/AppConfig';
import { incrementChatCount, incrementComplainCount } from 'functions/chat';
import service from 'auth/FetchInterceptor';
//import {getAdminUserData} from 'redux/actions/Auth';

import * as AntdIcons from '@ant-design/icons';
const { confirm } = Modal;

const { SubMenu } = Menu;
const { useBreakpoint } = Grid;

const setLocale = (isLocaleOn, localeKey) =>
	isLocaleOn ? <IntlMessage id={localeKey} /> : localeKey.toString();

const setDefaultOpen = (key) => {
	let keyList = [];
	let keyString = "";
	if (key) {
		const arr = key.split("-");
		for (let index = 0; index < arr.length; index++) {
			const elm = arr[index];
			index === 0 ? (keyString = elm) : (keyString = `${keyString}-${elm}`);
			keyList.push(keyString);
		}
	}
	return keyList;
};

const SideNavContent = (props) => {
	const { sideNavTheme, routeInfo, socket, hideGroupTitle, localization, onMobileNavToggle, userData, navigationConfig } = props;

	const isMobile = !utils.getBreakPoint(useBreakpoint()).includes('lg')
	const closeMobileNav = () => {
		if (isMobile) {
			onMobileNavToggle(false)
		}
	}

	const [totalReminder, setTotalReminder] = useState(0);
	const [totalStaffReminder, setTotalStaffReminder] = useState(0);
	const [totalCarReminder, setTotalCarReminder] = useState(0);
	const [carAccidentReminder, setCarAccidentReminder] = useState(0);
	const [approveReminder, setApproveReminder] = useState(0);


	const getTotalReminder = () => {
		service.get(ADMIN_API_BASE_ENDPOINT + 'utilities/reminders_count').then(response => {
			setTotalReminder(response.data.all_reminder);
			setTotalStaffReminder(response.data.staff_reminder);
			setTotalCarReminder(response.data.car_reminder);
			setApproveReminder(response.data.approve_reminder);
			setCarAccidentReminder(response.data.car_accident_reminder);
		});
	}

	const TotalVehicleReminder = totalCarReminder + carAccidentReminder;

	useEffect(() => {

		getTotalReminder();

	}, []);
	return (
		<Menu
			theme={sideNavTheme === SIDE_NAV_LIGHT ? "light" : "dark"}
			mode="inline"
			style={{ height: "100%", borderRight: 0 }}
			defaultSelectedKeys={[routeInfo?.key]}
			defaultOpenKeys={setDefaultOpen(routeInfo?.key)}
			className={hideGroupTitle ? "hide-group-title" : ""}
		>
			{navigationConfig.map((menu) => {
				const AntdParentIcon = AntdIcons[menu.icon];
				return (
					menu.submenu.length > 0 ? (
						
						menu.submenu.map((subMenuFirst) => {
							const AntdIcon = AntdIcons[subMenuFirst.icon];
							if(subMenuFirst.key === 'all_reminder'){
								console.log("subMenuFirst : ", subMenuFirst)
							}
							
							return (
								subMenuFirst.show === true && subMenuFirst.submenu.length > 0 ? (
									<SubMenu
										icon={
											subMenuFirst.icon ? (
												<AntdIcon />
											) : null
										}
										key={subMenuFirst.key}
										title={
											<>
											
												{subMenuFirst.title}
												<div style={{ float: "right" }}>
													{
														subMenuFirst.key === 'all_reminder' &&
														<span className="ant-badge ant-badge-not-a-wrapper mt-2" style={{ 'display': totalReminder > 0 ? 'block' : 'none' }}>
															<sup data-show="true" className="ant-scroll-number ant-badge-count" title="7">
																<span className="ant-scroll-number-only">
																	<span className="ant-scroll-number-only-unit current">{totalReminder}</span>
																</span>
															</sup>
														</span>
													}
													{
														subMenuFirst.key === 'approve_list' &&
														<span className="ant-badge ant-badge-not-a-wrapper mt-2" style={{ 'display': approveReminder > 0 ? 'block' : 'none' }}>
															<sup data-show="true" className="ant-scroll-number ant-badge-count" title="7">
																<span className="ant-scroll-number-only">
																	<span className="ant-scroll-number-only-unit current">{approveReminder}</span>
																</span>
															</sup>
														</span>
													}
													{
														subMenuFirst.key === 'manage_staff' &&
														<span className="ant-badge ant-badge-not-a-wrapper mt-2" style={{ 'display': totalStaffReminder > 0 ? 'block' : 'none' }}>
															<sup data-show="true" className="ant-scroll-number ant-badge-count" title="7">
																<span className="ant-scroll-number-only">
																	<span className="ant-scroll-number-only-unit current">{totalStaffReminder}</span>
																</span>
															</sup>
														</span>
													}
													{
														subMenuFirst.key === 'car_management' &&
														<span className="ant-badge ant-badge-not-a-wrapper mt-2" style={{ 'display': TotalVehicleReminder > 0 ? 'block' : 'none' }}>
															<sup data-show="true" className="ant-scroll-number ant-badge-count" title="7">
																<span className="ant-scroll-number-only">
																	<span className="ant-scroll-number-only-unit current">{TotalVehicleReminder}</span>
																</span>
															</sup>
														</span>
													}
													
													
												</div>
											</>
											}
										danger={true}
									>

										{
											subMenuFirst.submenu.map((subMenuSecond) => {
												const AntdSubIcon = AntdIcons[subMenuSecond.icon];
												return (
													subMenuSecond.show === true ?
														<Menu.Item key={subMenuSecond.key}>
															{subMenuSecond.icon ? (
																<AntdSubIcon />
															) : null}
															<span>
																{subMenuSecond.title}
																<div style={{ float: "right" }}>
																{
																	subMenuSecond.key === 'staff_reminders' &&
																	<span className="ant-badge ant-badge-not-a-wrapper mt-2" style={{ 'display': totalStaffReminder > 0 ? 'block' : 'none' }}>
																		<sup data-show="true" className="ant-scroll-number ant-badge-count" title="7">
																			<span className="ant-scroll-number-only">
																				<span className="ant-scroll-number-only-unit current">{totalStaffReminder}</span>
																			</span>
																		</sup>
																	</span>
																}
																{
																	subMenuSecond.key === 'car_reminders' &&
																	<span className="ant-badge ant-badge-not-a-wrapper mt-2" style={{ 'display': totalCarReminder > 0 ? 'block' : 'none' }}>
																		<sup data-show="true" className="ant-scroll-number ant-badge-count" title="7">
																			<span className="ant-scroll-number-only">
																				<span className="ant-scroll-number-only-unit current">{totalCarReminder}</span>
																			</span>
																		</sup>
																	</span>
																}
																{
																	subMenuSecond.key === 'car_accident_reminder' &&
																	<span className="ant-badge ant-badge-not-a-wrapper mt-2" style={{ 'display': carAccidentReminder > 0 ? 'block' : 'none' }}>
																		<sup data-show="true" className="ant-scroll-number ant-badge-count" title="7">
																			<span className="ant-scroll-number-only">
																				<span className="ant-scroll-number-only-unit current">{carAccidentReminder}</span>
																			</span>
																		</sup>
																	</span>
																}

																
																
																</div>
															</span>
															{
																subMenuSecond.key === 'route-map' ?
																	<Link target="_blank" onClick={() => closeMobileNav()} to={{ pathname: subMenuSecond.path}} />
																	:
																	<Link onClick={() => closeMobileNav()} to={subMenuSecond.path} />
															}

														</Menu.Item> : null
												)
											}
											)
										}
									</SubMenu>
								) : (
									subMenuFirst.show === true ?
										<Menu.Item key={subMenuFirst.key}>

											{subMenuFirst.icon ? <AntdIcon /> : null}
											<span>{subMenuFirst.title}</span>
											<div style={{ float: "right" }}>


											</div>

											<Link onClick={() => closeMobileNav()} to={subMenuFirst.path} />

										</Menu.Item>
										: null
								)
							)
						}
						)
						
					) : (
						<Menu.Item key={menu.key}>
							{menu.icon ? <AntdParentIcon /> : null}
							<span>{setLocale(localization, menu?.title)}</span>
							{menu.path ? <Link onClick={() => closeMobileNav()} to={menu.path} /> : null}
						</Menu.Item>
					)
				)
			}
			)}
		</Menu>
	);
};


const MenuContent = (props) => {

	const { location } = props;
	const history = useHistory();



	useEffect(() => {
		//REDIRECT ON ROUTE CHANGE
		const { pathname } = location;
		const userData = props.adminUserData

		const query = new URLSearchParams(props.location.search);
		const checkout_id = query.get('id')

		if ( userData !== undefined && userData.is_valid === false && checkout_id == null) {
			history.push({
				pathname: "/app/package/orders",
			});
		}

	}, [location.pathname]);
	return props.navigationConfig !== undefined && props.navigationConfig.length > 0 && props.type === NAV_TYPE_SIDE ? (
		<SideNavContent {...props} navigationConfig={props.navigationConfig} />
	) : (
		<></>
	);
};

const mapStateToProps = ({ theme, auth }) => {
	const { sideNavTheme, topNavColor } = theme;
	const { userData } = auth;
	return { sideNavTheme, topNavColor, userData };
};

// const mapDispatchToProps = {
// 	getAdminUserData,
// }

//export default withRouter(connect(mapStateToProps, mapDispatchToProps)(MenuContent));
export default withRouter(connect(mapStateToProps,  { onMobileNavToggle })(MenuContent));
